"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from "../../styles/clsx.js";
import { deprecatedSizeMap } from "../Body/Body.js";
import { deprecate } from "../../util/logger.js";
import classes from "./List.module.css.js";
const List = forwardRef(
  ({ className, variant = "unordered", size: legacySize = "m", ...props }, ref) => {
    if (process.env.NODE_ENV !== "production") {
      if (legacySize in deprecatedSizeMap) {
        deprecate(
          "List",
          `The "${legacySize}" size has been deprecated. Use the "${deprecatedSizeMap[legacySize]}" size instead.`
        );
      }
    }
    const Element = variant === "ordered" ? "ol" : "ul";
    const size = deprecatedSizeMap[legacySize] || legacySize;
    return /* @__PURE__ */ jsx(
      Element,
      {
        className: clsx(classes.base, classes[size], className),
        ...props,
        ref
      }
    );
  }
);
List.displayName = "List";
export {
  List
};
